import {Component} from '@angular/core';
import {
  ConfirmIconButtonComponent,
  DateElementComponent,
  dateObjectToISOString,
  DialogHeaderComponent,
} from "frontier";
import {MatDialogActions, MatDialogContent, MatDialogRef} from "@angular/material/dialog";
import {MatSlideToggle} from "@angular/material/slide-toggle";
import {PaginatorModule} from "primeng/paginator";
import {FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";

interface IRebookRecordsForm {
  fromDate: FormControl<string>;
  toDate: FormControl<string>;
  rebookAll: FormControl<boolean>;
}

export interface IRebookRecordsValue {
  fromDate: string;
  toDate: string;
  rebookAll: boolean;
}

@Component({
  selector: 'app-rebook-records-dialog',
  standalone: true,
  imports: [
    ConfirmIconButtonComponent,
    DateElementComponent,
    DialogHeaderComponent,
    MatDialogActions,
    MatDialogContent,
    MatSlideToggle,
    PaginatorModule,
    ReactiveFormsModule,

  ],
  templateUrl: './rebook-records-dialog.component.html',
  styleUrl: './rebook-records-dialog.component.scss'
})
export class RebookRecordsDialogComponent {
  form: FormGroup<IRebookRecordsForm>;

  constructor(
    public dialogRef: MatDialogRef<RebookRecordsDialogComponent>,
    private fb: FormBuilder,
  ) {
    this.form = fb.group<IRebookRecordsForm>({
      fromDate: fb.control(null, [Validators.required]),
      toDate: fb.control(null, [Validators.required]),
      rebookAll: fb.control(false),
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    const dialogRes: IRebookRecordsValue = {
      fromDate: dateObjectToISOString(this.form.value.fromDate),
      toDate: dateObjectToISOString(this.form.value.toDate),
      rebookAll: this.form.value.rebookAll ?? false,
    }
    this.dialogRef.close(dialogRes);
  }
}
